import {changeDateToSchema} from "./formatToMoscowISO";
import {NEXT_PUBLIC_BASE_URL} from "../../constants/copyright";
import {DEFAULT_SHARE_IMAGE, ORGANIZATION_LOGO} from "../../constants/seo";

function absoluteUrl(path) {
  if (!path) return NEXT_PUBLIC_BASE_URL;
  if (/^https?:\/\//i.test(path)) return path;
  return `${NEXT_PUBLIC_BASE_URL}${path.startsWith("/") ? path : `/${path}`}`;
}

export function getOrganizationMicrodata() {
  return {
    "@context": "https://schema.org",
    "@type": "NewsMediaOrganization",
    "name": "Медиа Столото",
    "url": NEXT_PUBLIC_BASE_URL,
    "logo": {
      "@type": "ImageObject",
      "url": ORGANIZATION_LOGO
    },
    "sameAs": [
      "https://vk.com/stoloto",
      "https://ok.ru/stoloto",
      "https://t.me/aboutstoloto",
      "https://rutube.ru/channel/23877067/"
    ]
  };
}

export function getItemListMicrodata(items = [], limit = 10) {
  const list = items
    .filter((item) => item?.href)
    .slice(0, limit);

  return {
    "@context": "https://schema.org",
    "@type": "ItemList",
    "numberOfItems": list.length,
    "itemListElement": list.map((item, index) => ({
      "@type": "ListItem",
      "position": index + 1,
      "url": absoluteUrl(item.href)
    }))
  };
}

export default function getMicrodata(data) {
  const {
    content: {
      type, href, title, preview, description, dateModified, datePublished, author, meta_title,
      meta_description, share_image
    }
  } = data;

  const dateMod = changeDateToSchema(dateModified);
  const dataPub = changeDateToSchema(datePublished);
  const image = preview || share_image || DEFAULT_SHARE_IMAGE;

  return {
    "@context": "https://schema.org",
    "@type": type || "Article",
    "mainEntityOfPage": {
      "@type": "WebPage",
      "@id": absoluteUrl(href)
    },
    "headline": meta_title ?? title,
    "image": [image],
    "datePublished": dataPub,
    "dateModified": dateMod || dataPub,
    "author": {
      "@type": "Person",
      "name": author ? `${author.first_name} ${author.last_name}` : "Медиа Столото",
      "url": author ? absoluteUrl(`/author/${author.slug}`) : NEXT_PUBLIC_BASE_URL
    },
    "publisher": {
      "@type": "Organization",
      "name": "Медиа Столото",
      "logo": {
        "@type": "ImageObject",
        "url": ORGANIZATION_LOGO
      }
    },
    "description": meta_description ?? description
  };
}
